<template>
  <div
    class="c-delivery"
  >
    <Typography
      class="-fontBold -title"
      v-text="$t('widgets.orderModal.delivery.addressLabel')"
      variant="body1"
    />
    <AddressBox
      @selected="getSelectedAddress"
      label-color="secondary"
      has-border
      icon-left
      id="delivery-address"
      placeholder="Search address"
      v-model="address"
    />
    <FieldLoader
      v-if="loadingList"
      class="h-mv-20"
    />
    <RestaurantList
      v-else
      :list="deliveryList"
      @change="getSelectedRestaurant"
      :selected-restaurant="selectedRestaurant"
      name="restaurant"
    />
    <div v-if="!deliveryList.length && address.length > 0">
      No Restaurants found!
    </div>
    <TimeAndDatePicker />
  </div>
</template>

<script setup>
import { inject } from 'vue';

import RestaurantList from '@/components/Order/RestaurantList.vue';
import TimeAndDatePicker from '@/components/Order/TimeAndDatePicker.vue';
import AddressBox from '@/components/common/AddressBox.vue';
import FieldLoader from '@/components/common/Loader/FieldLoader.vue';

const deliveryList = inject('deliveryList');
const address = inject('address');
const selectedRestaurant = inject('selectedRestaurant');
const getSelectedAddress = inject('getSelectedAddress');
const getSelectedRestaurant = inject('getSelectedRestaurant');
const loadingList = inject('loadingList');

</script>
